import { useContext, useMemo } from 'react';

import { Box, Card, LinearProgress, Typography } from '@occc-app/design-system';

import { useGetSiteConnectionHistorySummary } from '@occc-app/dataAccessLayer/site/queries';
import { LocationConnectionHistory } from './location-connection-history.component';
import { LocationConnectionHistorySummary } from './components/summary/connection-history-summary.component';
import { getDateRange } from './location-connection-history.utils';
import { LocationContext } from '../LocationProvider';

export const LocationConnectionHistoryContainer = () => {
  const { location } = useContext(LocationContext);

  const dateRange = useMemo(() => {
    return getDateRange();
  }, []);

  const {
    data: summaryData,
    error,
    loading,
    refetch: refetchSummary,
  } = useGetSiteConnectionHistorySummary({
    locationUuid: location?.uuid,
    dateRange,
  });

  if (!location) {
    return (
      <Card sx={{ py: 10, px: 2 }}>
        <Typography color='error' textAlign='center'>
          No data. Something went wrong. Please try again.
        </Typography>
      </Card>
    );
  }

  return (
    <>
      <LocationConnectionHistorySummary data={summaryData} error={error} loading={loading} />
      <Card>
        {loading && <LinearProgress />}
        <Box pt={1} pb={2}>
          <LocationConnectionHistory location={location} onReload={refetchSummary} />
        </Box>
      </Card>
    </>
  );
};
